import Vue from 'vue'

export default {
    SET_LOCALE (state, value) {
        state.locale = value
    },
    SET_LOADING (state, value) {
        state.loading = value
    },
    SET_CURRENCY (state, value) {
        state.currency = value
    },
    TOGGLE_LOTS (state, value) {
        state.showLots = !state.showLots
    },
    SET_USER (state, value) {
        state.user = value
    },
    SET_AUCTION (state, value) {
        state.auction = {...state.auction, ...value}
    },
    SET_STREAM (state, value) {
        if(state.auction) {
            Vue.set(state.auction, 'cs', value)
        }
    },
    SET_LOT (state, value) {
        let index = state.lots.findIndex(lot => {
            return lot.id == value.id
        })

        if(value.w) {
            state.winner = value.w
        } else {
            state.winner = null
        }

        if(value.b) {
            state.bids = state.bids.concat(value.b.filter(bid => bid.a >= value.k))
        } else {
            state.bids.splice(0)
        }

        if(index >= 0) {
            Vue.set(state.lots, index, {...state.lots[index], ...value})
        } else {
            Vue.set(state.lots, 0, {...state.lots[0], ...value})
        }
    },
    SET_CURRENT_LOT (state, value) {
        state.lot = value.id
    },
    SET_LOTS (state, value) {
        state.lots = value
    },
    SET_SELECTED_LOT (state, value) {
        state.selectedLot = value
    },
    SET_BIDDERS (state, value) {
        state.bidders = value
    },
    ADD_BID (state, value) {
        if(! state.lot) return
        const lot = state.lots.find(item => {
            return item.id == state.lot
        })
        if(! lot) return
        if(value.a < lot.k) return
        state.bids.push(value)
    },
    ADD_BIDS (state, value) {
        state.bids = state.bids.concat(value)
    },
    RESET_BIDS (state, value) {
        state.bids.splice(0)
    },
    SET_WIN (state, value) {
        let index = state.lots.findIndex(lot => {
            return lot.id == value.lid
        })
        if(index >= 0) {
            state.lots[index].p = value.p
            state.lots[index].k = value.k
        }
        state.winner = value
    },
    RESET_WINNER (state, value) {
        state.winner = null
    },
    SET_WARN (state, value) {
        if(! value) return
        let index = state.lots.findIndex(lot => {
            return lot.id == value.id
        })
        if(index >= 0) {
            state.lots[index].warn = 1
        }
    },
    ADD_MESSAGE (state, value) {
        state.messages.push(value)
    },
    RESET_MESSAGES (state) {
        state.messages.length = 0
    },
    SET_TIMER (state, timer) {
        state.timer = timer
    },
    DECREASE_TIMER (state) {
        if(state.timer <= 0) return
        
        state.timer --;
    },
    INCREASE_TIMER (state, seconds) {
        if(state.timer <= 0) return
        
        state.timer += seconds;
    }
}
